import { Text, View } from '@components/primitives';
import { MaterialIcons } from '@expo/vector-icons';
import navigationConstants from '@navigation/navigationConstants';
import { useNavigation } from '@react-navigation/native';
import colors from '@theme/colors';
import React from 'react';
import { Pressable } from 'react-native';
import { useTranslation } from 'react-i18next';
import styles from './styles';

export type NotificationFilterKey = 'all' | 'info' | 'message';

const filterKeys: NotificationFilterKey[] = ['all', 'info', 'message'];
export const DEFAULT_NOTIFICATION_FILTER: NotificationFilterKey = 'all';

export const isNotificationFilterSelected = (
  selectedFilter: NotificationFilterKey,
  filterKey: NotificationFilterKey,
): boolean => selectedFilter === filterKey;

export const notificationSettingsPressHandler = (navigation: { navigate: (screen: string) => void }): (() => void) => {
  return () => navigation.navigate(navigationConstants.NOTIFICATION_SETTINGS);
};

interface NotificationFiltersProps {
  onSelectFilter: (filterKey: NotificationFilterKey) => void;
  selectedFilter: NotificationFilterKey;
}

function NotificationFilters({ onSelectFilter, selectedFilter }: NotificationFiltersProps): React.JSX.Element {
  const { t } = useTranslation('common');
  const navigation = useNavigation<any>();

  return (
    <View style={styles.container}>
      <View style={styles.chipRow}>
        {filterKeys.map(filterKey => {
          const isSelected = isNotificationFilterSelected(selectedFilter, filterKey);

          return (
            <Pressable
              key={filterKey}
              testID={`notification-filter-${filterKey}`}
              onPress={() => onSelectFilter(filterKey)}
              style={[styles.chip, isSelected ? styles.chipSelected : null]}>
              <Text style={[styles.chipLabel, isSelected ? styles.chipLabelActive : null]} variant="md-bold">
                {t(`notifications.filters.${filterKey}`)}
              </Text>
            </Pressable>
          );
        })}
      </View>
      <Pressable
        testID="notification-settings-button"
        onPress={notificationSettingsPressHandler(navigation)}
        style={styles.settingsButton}>
        <MaterialIcons color={colors.neutral.charcoal} name="settings" size={32} />
      </Pressable>
    </View>
  );
}

export default NotificationFilters;
